<template>
    <div class="lms__user_reward_edit">
        <form-text
            :name="'lms-user-achievements-reward-name'"
            :label="$t('lms.user.reward.labels.rewardName')"
            :v-validate="'required|max:200'"
            :required="true"
            :data-vv-as="$t('forms.dataVvAs.name')"
            v-model="achievementsCertificateName"
        />
        <form-textarea
            :required="true"
            :label="$t('lms.user.reward.labels.description')"
            :name="'lms-user-achievements-reward-description'"
            :v-validate="'required|max:255'"
            v-model="achievementsCertificateDescription"
        />
        <form-select
            class="lms__user_reward_edit_select"
            :disabled="true"
            :label="$t('lms.user.reward.labels.rewardType')"
            :items="[
                {
                    label: $t('lms.user.reward.labels.certificate'),
                    value: 'certificate'
                }
            ]"
            :name="'lms-user-achievements-reward-select'"
            :value="'certificate'"
            :is-type="'select'"
            :placeholder="$t('lms.user.reward.labels.certificate')"
            :searchable="false"
            @input="''"
        />
        <form-editor
            ref="formeditor"
            :name="'lms-user-achievement-reward-description'"
            :label="$t('lms.user.reward.labels.content')"
            :required="true"
            :v-validate="'required'"
            :tags="tagsContent"
            v-model="achievementsCertificateHtml"
        />
        <form-submit
            :reset-button-text="$t('lms.user.achievements.buttons.resetChanges')"
            :submit-button-text="$t('lms.user.achievements.buttons.saveAchievement')"
            @reset="performReset"
            @submit="performSubmitValidate"
        />
        <pop-notify
            ref="popnotifyvalidation"
            :class="'pop__notify--validation'"
            :title-text="`Something's not quite right`"
            :content-text="'Please check that you have filled out all the fields in the form correctly and try again.'"
            :cancel-button-text="'Ok'"
            :submit-button-active="false"
        />
    </div>
</template>

<script>
import FormText from '@/components/default/forms/FormText'
import FormTextarea from '@/components/default/forms/FormTextarea'
import FormSelect from '@/components/default/forms/FormSelect'
import FormEditor from '@/components/default/forms/FormEditor'
import PopNotify from '@/components/default/shared/PopNotify'
import FormSubmit from '@/components/default/forms/FormSubmit'
import { performSubmitValidate, performReset, validateBeforeRouteLeave, watchContentChangeEmit } from '@/helpers/mixins'
export default {
  name: 'lms-user-rewards-edit-form',
  mixins: [validateBeforeRouteLeave, performReset, performSubmitValidate, watchContentChangeEmit],
  components: {
    FormText,
    FormTextarea,
    FormSelect,
    FormEditor,
    PopNotify,
    FormSubmit
  },
  computed: {
    achievementsCertificateName: {
      get () {
        return this.$store.getters.getLmsUserRewardName
      },
      set (value) {
        this.$store.dispatch('lmsUserRewardName', value)
      }
    },
    achievementsCertificateDescription: {
      get () {
        return this.$store.getters.getLmsUserRewardDescription
      },
      set (value) {
        this.$store.dispatch('lmsUserRewardDescription', value)
      }
    },
    achievementsCertificateHtml: {
      get () {
        return this.$store.getters.getLmsUserRewardHtml
      },
      set (value) {
        this.$store.dispatch('lmsUserRewardHtml', value)
      }
    },
    tagsContent () {
      return this.$store.getters.getTagsContentMapped
    },
    //
    rootItemName () {
      return 'reward'
    },
    nameActionCreate () {
      return 'lmsUserRewardCreate'
    },
    nameActionUpdate () {
      return 'lmsUserRewardUpdate'
    },
    nameActionReset () {
      return 'lmsUserRewardClear'
    },
    watchContent () {
      return this.achievementsCertificateName + this.achievementsCertificateDescription + this.achievementsCertificateHtml
    }
  },
  methods: {
    getTagsContent () {
      return this.$store.dispatch('tagsContentGet')
    }
  },
  created () {
    this.getTagsContent()
  }
}
</script>
